import { FormControl, FormGroup, FormLabel, TextField } from "@mui/material";
import { SftpSettings } from "../../api";
import { PasswordField } from "../controls";

export interface SftpSettingsControlProps {
  settings?: SftpSettings;
  onChange: (settings: Partial<SftpSettings>) => void;
}

export const SftpSettingsControl = (props: SftpSettingsControlProps) => {
  const { settings, onChange } = props;

  return (
    <FormControl component="fieldset" sx={{ minWidth: 150 }}>
      <FormLabel component="legend">SFTP settings</FormLabel>
      <FormGroup>
        <TextField label="Host" required variant="standard" value={settings?.host ?? ""} onChange={(e) => onChange({ host: e.target.value })} />
        <TextField label="Username" variant="standard" value={settings?.username ?? ""} onChange={(e) => onChange({ username: e.target.value })} />
        <PasswordField label="Password" variant="standard" value={settings?.password ?? ""} onChange={(e) => onChange({ password: e.target.value })} />
        <TextField label="Port" variant="standard" type="number" value={settings?.port ?? ""} onChange={(e) => onChange({ port: e.target.value })} />
      </FormGroup>
    </FormControl>
  );
};
